webpackJsonp([152964788672952],{

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _navigation = __webpack_require__(13);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _footer = __webpack_require__(12);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _seo = __webpack_require__(38);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	var _seo3 = __webpack_require__(44);
	
	var _seo4 = _interopRequireDefault(_seo3);
	
	var _registerNowLeft = __webpack_require__(23);
	
	var _registerNowLeft2 = _interopRequireDefault(_registerNowLeft);
	
	var _cover = __webpack_require__(19);
	
	var _cover2 = _interopRequireDefault(_cover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Seo = function (_React$Component) {
		(0, _inherits3.default)(Seo, _React$Component);
	
		function Seo() {
			(0, _classCallCheck3.default)(this, Seo);
			return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
		}
	
		Seo.prototype.pageClick = function pageClick(e) {
			document.getElementsByTagName('body')[0].className = '';
		};
	
		Seo.prototype.componentDidMount = function componentDidMount() {
			var mask = document.getElementById('mask');
			mask.addEventListener('touchstart', this.pageClick, false);
		};
	
		Seo.prototype.render = function render() {
			return _react2.default.createElement(
				"div",
				null,
				_react2.default.createElement(_reactHelmet2.default, {
					title: "Part Time Jobs - UvoCorp.com",
					meta: [{ name: "description", content: "Part time jobs for writers all over the world. Sign up, pass grammar test and start earning now!" }, { property: 'og:title', content: "Part Time Jobs - UvoCorp.com" }, { property: 'og:description', content: "Part time jobs for writers all over the world. Sign up, pass grammar test and start earning now!" }, { property: 'og:site_name', content: "UvoCorp.com" }, { property: 'og:type', content: "website" }, { property: 'og:image', content: _cover2.default }],
					link: [{ rel: 'canonical', href: "https://www.uvocorp.com/part_time_jobs.html" }] }),
				_react2.default.createElement(
					"div",
					{ className: "header", id: "header" },
					_react2.default.createElement(_navigation2.default, null)
				),
				_react2.default.createElement(
					"div",
					{ className: "wrapper" },
					_react2.default.createElement(
						"div",
						{ className: "inner-header" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"h1",
								null,
								"Part time jobs"
							),
							_react2.default.createElement(
								_gatsbyLink2.default,
								{ to: "/register_email.html" },
								"Register now"
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "home-benefits home-block hiring-benefits" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"h1",
								null,
								"The benefits you enjoy working as a freelance writer:"
							),
							_react2.default.createElement(
								"ul",
								{ className: "home-benefits-list" },
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-1" },
									_react2.default.createElement(
										"p",
										null,
										"No registration fees"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-2" },
									_react2.default.createElement(
										"p",
										null,
										"High wages"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-3" },
									_react2.default.createElement(
										"p",
										null,
										"Working from home"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-4" },
									_react2.default.createElement(
										"p",
										null,
										"Orders in the sphere ",
										_react2.default.createElement("br", null),
										"of your interest"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-5" },
									_react2.default.createElement(
										"p",
										null,
										"24/7 available ",
										_react2.default.createElement("br", null),
										"support team"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-6" },
									_react2.default.createElement(
										"p",
										null,
										"Payments always ",
										_react2.default.createElement("br", null),
										"on time"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-7" },
									_react2.default.createElement(
										"p",
										null,
										"Manage your time ",
										_react2.default.createElement("br", null),
										"and workload yourself"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "home-pricing-info" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"p",
								null,
								"There is no other company that offers ",
								_react2.default.createElement(
									"strong",
									null,
									"$15"
								),
								"/page written by an ",
								_react2.default.createElement(
									"span",
									{ className: "home-pricing-info-role" },
									"ESL"
								),
								" writer and ",
								_react2.default.createElement(
									"strong",
									null,
									"$26"
								),
								"/page completed by an ",
								_react2.default.createElement(
									"span",
									{ className: "home-pricing-info-role" },
									"ENL"
								),
								" writer."
							),
							_react2.default.createElement(
								_gatsbyLink2.default,
								{ to: "/prices.html" },
								"View Pricing ",
								_react2.default.createElement(
									"svg",
									{ id: "arrow-right", width: "22", height: "22" },
									_react2.default.createElement("path", { fill: "#black", d: "M17.2,10.2l-3.2,3c-0.1,0.1-0.2,0.1-0.3,0c-0.1,0-0.2-0.1-0.2-0.2v-1.9H3c-0.2,0-0.3-0.1-0.3-0.3V9.2 C2.8,9,2.9,8.9,3,8.9h10.5V7.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0l3.2,2.9c0.1,0.1,0.1,0.1,0.1,0.2 C17.2,10.1,17.2,10.1,17.2,10.2z" })
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "inner-white hiring seo" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"h2",
								null,
								"Writers wanted"
							),
							_react2.default.createElement(
								"div",
								{ className: "row" },
								_react2.default.createElement(
									"div",
									{ className: "col-md-9" },
									_react2.default.createElement(
										"p",
										null,
										"Dear potential ",
										_react2.default.createElement(
											_gatsbyLink2.default,
											{ to: "/" },
											"UVOCORP"
										),
										" writers, we are currently hiring:"
									),
									_react2.default.createElement(
										"ol",
										{ className: "hiring-steps" },
										_react2.default.createElement(
											"li",
											null,
											"Writers who are Native Speakers of English (these writers have exclusive access to orders which need to be written by a Native Speaker of English);"
										),
										_react2.default.createElement(
											"li",
											null,
											"English as a Second Language writers with a profound knowledge in Humanities, Business Studies, Applied, and Social Sciences;"
										),
										_react2.default.createElement(
											"li",
											null,
											"Writers with a profound knowledge in the following disciplines. Working only on them on a permanent basis is our internal separate project:"
										)
									),
									_react2.default.createElement(
										"ul",
										{ className: "hiring-disciplines" },
										_react2.default.createElement(
											"li",
											{ className: "discipline_8" },
											"Accounting"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_15" },
											"Architecture, Building and Planning"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_14" },
											"Biology (and other Life Sciences)"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_13" },
											"Chemistry"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_1" },
											"Engneering"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_10" },
											"Civil Engineering"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_7" },
											"Computer Science"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_5" },
											"IT, Web"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_3" },
											"Finance"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_11" },
											"Mathematics"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_12" },
											"Physics"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_4" },
											"Statistics"
										)
									)
								),
								_react2.default.createElement(
									"div",
									{ className: "hiring-img" },
									_react2.default.createElement("img", { src: _seo4.default, alt: "Seo Image" })
								)
							),
							_react2.default.createElement(
								"div",
								{ className: "row seo-row" },
								_react2.default.createElement(
									"div",
									{ className: "col-md-4 seo-img-container" },
									_react2.default.createElement(
										"div",
										{ className: "seo-img" },
										_react2.default.createElement("img", { src: _seo2.default, alt: "Seo Image" })
									)
								),
								_react2.default.createElement(
									"div",
									{ className: "col-md-8" },
									_react2.default.createElement(
										"h2",
										{ className: "left" },
										"What Are the Reasons to Take up Part Time Jobs?"
									),
									_react2.default.createElement(
										"p",
										null,
										"Stop and think. If you could create the perfect job, what would be some of the things that would go into creating it? Many people have already asked themselves that same question and this is the list of things they come up with: I like to be my own boss, I need flexible hours, and I am trying to conserve fuel. It\u2019s also important to have a job that pays well and that you feel has value; a lot of people also hate doing the same thing day after day. When things get boring, we find that it's hard to do a very good job after a while. Some people really enjoy learning new things, too."
									),
									_react2.default.createElement(
										"p",
										null,
										"So how could one find a job that would be all these things? While no job is perfect we have found one that fits a lot of the ideas of what work is the best, and the job that fits this list is being a freelance writer. If you have always liked to write and even in high school, you were a person who enjoyed writing and researching you should apply for such a job. If it is something you are good at, and you can as well use your college training, taking a job as a freelance writer, you will be able to write as much or as little as you want; you decide whether you want your writing to be a part time job or something that you can do full time."
									),
									_react2.default.createElement(
										"h2",
										{ className: "inner-left-intext" },
										"The Benefits of Working as a Freelance Writer Part Time"
									),
									_react2.default.createElement(
										"p",
										null,
										"It is convenient to work for ",
										_react2.default.createElement(
											_gatsbyLink2.default,
											{ to: "/" },
											"UvoCorp.com"
										),
										" because there is always plenty of work to take. Sometimes you will be assigned to work on papers, but the staff is really good at choosing articles that would fit your background and interests. You will also have the freedom to choose what you want to work on. In that way, You are your own boss; you can take as many or as few orders as you choose with deadlines that you are able to meet. Unlike most part time jobs, you can set your own schedule. With a goal in mind, working from home you decide how much per hour you want to make. When you gain experience and star writing faster and more efficiently, you are able to make more money. By then, you can surpass your original goal. That is another plus of working with UvoCorp.com; they pay well for the work that you do. Some of the work here may be challenging, but it is worth it because you are well compensated for the time and effort. Plus I am learning new things all the time. You will write articles and papers for people literally around the world. It is exciting to know that something you worked on will be read by people half a world away from you."
									),
									_react2.default.createElement(
										"p",
										null,
										_react2.default.createElement(
											_gatsbyLink2.default,
											{ to: "/work_from_home_online.html" },
											"Working from home"
										),
										" and setting your own hours, you can plan around your family\u2019s activities. You don't have to miss school functions and meetings because you have to work. You don't have to miss classes because you need money to pay for necessities and there's no need working in the evening or on weekends because it took time away from your family and studies. Working part time as a freelance writer can be a good source of income. You don\u2019t have to worry about sick days, snow days, or summer vacations, either. You can be a stay-at-home mom and still be earning money. Plus, you can save hundreds of dollars because you don\u2019t have to commute back and forth to work, too. Which is especially convenient for students, who need all the time they can get to manage everything."
									),
									_react2.default.createElement(
										"p",
										null,
										"Do not waste your time on something you are not comfortable with, and pursue a writing career with UvoCorp!"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "inner-registration inner-registration-left" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"div",
								{ className: "inner-registration-image" },
								_react2.default.createElement(
									"div",
									{ className: "img inner-registration-img" },
									_react2.default.createElement("img", { src: _registerNowLeft2.default, alt: "Start registration" })
								)
							),
							_react2.default.createElement(
								"div",
								{ className: "inner-registration-text" },
								_react2.default.createElement(
									"div",
									{ className: "inner-registration-title" },
									"Register now ",
									_react2.default.createElement("br", null),
									"to start earning!"
								),
								_react2.default.createElement(
									"div",
									{ className: "inner-registration-button" },
									_react2.default.createElement(
										_gatsbyLink2.default,
										{ to: "/register_email.html" },
										"Start registration"
									)
								)
							)
						)
					),
					_react2.default.createElement(_footer2.default, null)
				),
				_react2.default.createElement("div", { id: "mask", className: "c-mask" })
			);
		};
	
		return Seo;
	}(_react2.default.Component);
	
	exports.default = Seo;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-part-time-jobs-html-js-402ab8aedada02fa7d11.js